<mat-drawer-container class="h-full" autosize="false">
  <mat-drawer disableClose mode="side" opened="true">
    <div
      class="text-xs uppercase tracking-widest font-medium pb-2 px-8 before:w-0 before:h-8 before:align-0 before:inline-block"
    >
      <span>Instellingen</span>
    </div>
    <nav class="flex flex-col pb-4 mx-4">
      @for (menuItem of menuItems(); track $index) {
        <a
          class="flex items-center gap-2 px-3.5 text-sm rounded-full font-medium h-8 hover:bg-gray-200 hover:text-gray-800 [.active]:bg-secondary-200 [.active]:text-secondary-800 transition-colors"
          [routerLink]="menuItem.route"
          routerLinkActive="active"
        >
          <mat-icon class="shrink-0 size-5! text-xl! leading-none!">{{
            menuItem.icon
          }}</mat-icon>

          <span class="flex-auto truncate">{{ menuItem.label }}</span>
        </a>
      }
    </nav>

    @if (aiAgentMenuItems().length) {
      <div
        class="text-xs uppercase tracking-widest font-medium pb-2 px-8"
      >
        <span>AI-agents</span>
      </div>
      <nav class="flex flex-col pb-4 mx-4">
        @for (menuItem of aiAgentMenuItems(); track $index) {
          <a
            class="flex items-center gap-2 px-3.5 text-sm rounded-full font-medium h-8 hover:bg-gray-200 hover:text-gray-800 [.active]:bg-secondary-200 [.active]:text-secondary-800 transition-colors"
            [routerLink]="menuItem.route"
            routerLinkActive="active"
          >
            <mat-icon class="shrink-0 size-5! text-xl! leading-none!">{{
              menuItem.icon
            }}</mat-icon>

            <span class="flex-auto truncate">{{ menuItem.label }}</span>
          </a>
        }
      </nav>
    }

    @if (logMenuItems().length) {
    <div
      class="text-xs uppercase tracking-widest font-medium pb-2 px-8"
    >
      <span>Logs</span>
    </div>
    <nav class="flex flex-col pb-4 mx-4">
      @for (menuItem of logMenuItems(); track $index) {
        <a
          class="flex items-center gap-2 px-3.5 text-sm rounded-full font-medium h-8 hover:bg-gray-200 hover:text-gray-800 [.active]:bg-secondary-200 [.active]:text-secondary-800 transition-colors"
          [routerLink]="menuItem.route"
          routerLinkActive="active"
        >
          <mat-icon class="shrink-0 size-5! text-xl! leading-none!">{{
            menuItem.icon
          }}</mat-icon>

          <span class="flex-auto truncate">{{ menuItem.label }}</span>
        </a>
      }
      </nav>
    }

    @if (actionsMenuItems().length) {
    <div
      class="text-xs uppercase tracking-widest font-medium pb-2 px-8"
    >
      <span>Acties</span>
    </div>
    <nav class="flex flex-col pb-4 mx-4">
      @for (menuItem of actionsMenuItems(); track $index) {
        <a
          class="flex items-center gap-2 px-3.5 text-sm rounded-full font-medium h-8 hover:bg-gray-200 hover:text-gray-800 [.active]:bg-secondary-200 [.active]:text-secondary-800 transition-colors"
          [routerLink]="menuItem.route"
          routerLinkActive="active"
        >
          <mat-icon class="shrink-0 size-5! text-xl! leading-none!">{{
            menuItem.icon
          }}</mat-icon>

          <span class="flex-auto truncate">{{ menuItem.label }}</span>
        </a>
      }
      </nav>
    }
  </mat-drawer>

  <mat-drawer-content class="bg-gray-100 !flex flex-col !transition-none">
    <div class="flex-auto overflow-auto scrollbar-width-thin">
      <router-outlet />
    </div>
  </mat-drawer-content>
</mat-drawer-container>
